var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _vm.store
          ? _c("div", { attrs: { id: "categories" } }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "a",
                      {
                        staticClass: "back-button",
                        attrs: { href: "javascript:history.go(-1)" }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "arrow-left"], size: "lg" }
                        }),
                        _vm._v(" Retornar à página principal")
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "page-title" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.store.Info.name))]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Lista de todos os descontos")])
                    ]),
                    _vm._v(" "),
                    _vm.coupons && _vm.coupons.length == 0
                      ? _c("div", { staticClass: "no-coupons" }, [
                          _c("h5", [
                            _vm._v(
                              "Não há ofertas disponíveis para essa loja no momento."
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Deseja receber novidades desta loja? Insira seu e-mail abaixo:"
                            )
                          ]),
                          _vm._v(" "),
                          _c("form", [
                            _c("div", { staticClass: "form-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                staticClass: "news-coupon form-control",
                                attrs: {
                                  placeholder: "Informe o seu e-mail",
                                  readonly: _vm.readonly,
                                  type: "email"
                                },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.msg
                              ? _c("small", [_vm._v(_vm._s(_vm.msg))])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.msgErro
                              ? _c("small", { staticClass: "error" }, [
                                  _vm._v(_vm._s(_vm.msgErro))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.msgSucesso
                              ? _c("small", { staticClass: "success" }, [
                                  _vm._v(_vm._s(_vm.msgSucesso))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-lg",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.submitNewsletter()
                                  }
                                }
                              },
                              [_vm._v("Cadastrar")]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.coupons && _vm.coupons.length > 0
                      ? _c(
                          "div",
                          { staticClass: "result" },
                          _vm._l(_vm.coupons, function(coupon, c) {
                            return _c(
                              "div",
                              {
                                key: c,
                                staticClass: "row coupon",
                                on: {
                                  click: function($event) {
                                    return _vm.openCouponModal(coupon)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("div", { staticClass: "image" }, [
                                    _c("img", {
                                      attrs: { src: _vm.store.logo }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  coupon.category
                                    ? _c("div", { staticClass: "categorie" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(coupon.category))
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "coupon-info" }, [
                                    _c("div", { staticClass: "info" }, [
                                      _c("h4", [_vm._v(_vm._s(coupon.store))]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(coupon.description))
                                      ]),
                                      _vm._v(" "),
                                      coupon.value > 100
                                        ? _c("span", { staticClass: "value" }, [
                                            _vm._v("R$ " + _vm._s(coupon.value))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      coupon.value < 100
                                        ? _c("span", { staticClass: "value" }, [
                                            _vm._v(_vm._s(coupon.value) + "%")
                                          ])
                                        : _c("span", [_vm._v(" ")])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "action" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn",
                                          on: {
                                            click: function($event) {
                                              return _vm.openCouponModal(coupon)
                                            }
                                          }
                                        },
                                        [_vm._v("Ver Desconto")]
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.store.description
                  ? _c("div", { staticClass: "row description" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.store.description) }
                        })
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("CouponModal", {
        ref: "couponModal",
        attrs: { coupon: _vm.selectedCoupon, store: _vm.store }
      }),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading", {
            attrs: { message: "Aguarde, carregando descontos da loja..." }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "mustLogin",
          attrs: { "hide-footer": "", title: "Você não está logado" }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h3", [
              _vm._v("Olá! Você precisa estar logado para visualizar o cupom.")
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-success", block: "" },
              on: { click: _vm.goToLogin }
            },
            [_vm._v("Entrar")]
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("Fechar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-192bf38e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-192bf38e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/descontosdobem/Store.vue
// module id = null
// module chunks = 